import React, { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import AppBar from '@mui/material/AppBar';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Layout from '../components/Layout';
import { Link } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import WarningIcon from '@mui/icons-material/Warning';
import { logIn } from '../utility/index.js';
import moment from 'moment';
import strings from '../utility/strings.js';
import {useAppState} from '../../index.js';

const FavoritesLink = React.forwardRef((props, ref) => <Link to="/favorites/" {...props} ref={ref} />);
const UpcomingLink = React.forwardRef((props, ref) => <Link to="/favorites/upcoming/" {...props} ref={ref} />);

const Upcoming = (props) => {
  const { AppContext, currentUser } = props;
  const { styleprops } = useContext(AppContext);
  const value = 1;
  const [favorites, setFavorites] = useState([]);
  const [upcoming, setUpcoming] = useState([]);

  useEffect(() => {
    if(currentUser !== 'Guest' && currentUser !== undefined) {
      setFavorites(currentUser.favorites);
    }
  }, [currentUser])

  useEffect(() => {
    if (favorites.length > 0) {
      let appearanceArray = [];
      let apperancePeriodArray = [];
      favorites.forEach((x) => {
        if(x.item.appearances.length > 0) {
          let itemAppearances = x.item.appearances.map((y) => {
            return {
              favoriteId: x.id,
              itemId: x.item.itemId,
              itemName: x.item.name,
              date: y.date,
              locationName: y.locationName,
              mealName: y.mealName,
              stationName: y.stationName
            }
          });
          appearanceArray.push(...itemAppearances);
        }
      });
  
      appearanceArray.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
  
      appearanceArray.forEach((day, index) => {
        if (index === 0) {
          apperancePeriodArray.push({
            day: day.date,
            favorites: [day]
          });
        }
        else if (moment(day.date).format('YYYY-MM-DD') === moment(apperancePeriodArray[apperancePeriodArray.length - 1].day).format('YYYY-MM-DD')) {
          apperancePeriodArray[apperancePeriodArray.length - 1].favorites.push(day)
        }
        else {
          apperancePeriodArray.push({
            day: day.date,
            favorites: [day]
          })
        }
      });
      setUpcoming(apperancePeriodArray);
    }
  }, [favorites])

  const renderBlank = () => {
    let loggedIn = currentUser !== "Guest" ? true : false;
    let message = (loggedIn ? strings.nullfavorites : strings.loginfavorites);
    let icon = (loggedIn ? <WarningIcon /> : <ErrorOutlineIcon />);
    let status = (loggedIn ? '' : 'error');

    return (
      <div className="login_message" >
        <div className={"message " + status} onClick={loggedIn ? null : () => logIn()}><div className="icon">{icon}</div><div className="text">{message}</div></div>
        {loggedIn ? null : <span className="userpanel-account-link null-login-link" onClick={() => logIn()}><LockIcon /><span>Login</span></span>}
      </div>
    )
  }

  let ListView = upcoming.length > 0 ? upcoming.map((x, i) => {
    // check to see if today or tomorrow, if true then return respective string rather than date.
    let date = moment().isSame(x.day, 'day') ? "Today" : moment().add(1, 'd').isSame(x.day, 'day') ? "Tomorrow" : moment(x.day).format('dddd, MMMM DD, YYYY');
    let favorites = x.favorites.map((y, i) => {
      let linkformat = moment(y.date).format('/YYYY/M/D/') + encodeURIComponent(y.mealName) + "/";
      return (
        <Link to={"/" + y.locationName + linkformat} aria-label={y.itemName + " " + y.locationName + " " + y.mealName + " " + moment(y.date).format('h:mm a')} className="upcoming-favorites__favorites--item" key={i}>
          <div>
            <div className="upcoming-favorites__favorites--title">{y.itemName}</div>
            <div className="upcoming-favorites__favorites--location">{y.locationName}</div>
          </div>
          <div>
            <div className="upcoming-favorites__favorites--meal">{y.mealName}</div>
            <div className="upcoming-favorites__favorites--time">{moment.parseZone(y.date).format('h:mm a')}</div>
          </div>
          <div className="upcoming-favorites__favorites--arrow"><KeyboardArrowRightIcon /></div>
        </Link>
      )
    })

    return (
      <div className="upcoming-favorites__day" key={i}>
        <div className="upcoming-favorites__day--title">{date}</div>
        <div className="upcoming-favorites__day--favorites">{favorites}</div>
      </div>
    )

  }) :
    <div className="upcoming-favorites__null">{currentUser !== 'Guest' ? "Loading your upcoming favorites." : "There are no upcoming favorites at this time."}</div>
  
  // TODO: The above loading message does not ever fire as the API fetch for this page has changed.
  return (
    <main className={"mdl-layout__content"} style={{ ...styleprops, paddingTop: 68 }}>
      <div className="mdl-layout__content-page" id="main">
        <AppBar position="static">
          <Tabs classes={{ root: "favorites__tabbar", indicator: "favorites__tabbar--indicator" }} value={value}>
            <Tab classes={{ wrapper: "favorites__tabbar--tab" }} label="Favorite Items" component={FavoritesLink} />
            <Tab classes={{ wrapper: "favorites__tabbar--tab" }} label="Upcoming Favorites" component={UpcomingLink} />
          </Tabs>
        </AppBar>
        {currentUser !== "Guest" ?

          <div className="upcoming-favorites--container">
            {ListView}
          </div>
          :
          renderBlank()}
      </div>
    </main>
  )
}

const Favorites = (props) => {
  const {locations, currentUser, GET_USER} = useAppState();
  const {AppContext} = props;
  return (
    <>
      <Helmet>
        <title>Upcoming Favorites - Purdue Dining Menus</title>
        <meta name="description" content="View your upcoming favorite menu items scheduled to appear at Purdue University dining locations." />
        <meta name="keywords" content="upcoming favorites, future meals, Purdue dining schedule, favorite foods schedule" />
        <meta property="og:title" content="Upcoming Favorites - Purdue Dining" />
        <meta property="og:description" content="View your upcoming favorite menu items at Purdue dining locations." />
      </Helmet>
      <Layout AppContext={AppContext} locations={locations} currentUser={currentUser} GET_USER={GET_USER} pageName="Upcoming Favorites">
        <Upcoming AppContext={AppContext} locations={locations} currentUser={currentUser} GET_USER={GET_USER} />
      </Layout>
    </>
  );
}

export default Favorites;